import React from 'react';
import { useContainer } from 'unstated-next';
import AdminSettingsContainer from '../AdminSettingsContainer';
import { UnauthorizedUserAccess } from '../../../types/adminConfig';
import UnauthorizedUserAccessView from './UnauthorizedUserAccessView';

const UnauthorizedUserAccessSetting: React.FC = () => {
    const { adminSettings, setAdminSettings } = useContainer(AdminSettingsContainer);
    const { authSettings } = adminSettings;

    const setSetting = (settings: UnauthorizedUserAccess) => {
        authSettings.unauthorizedUserAccess = settings;
        authSettings.unauthorizedUserText = null;
        setAdminSettings({ ...adminSettings });
    };

    const setText = (text: string) => {
        authSettings.unauthorizedUserText = text;
        setAdminSettings({ ...adminSettings });
    };

     return (
        <UnauthorizedUserAccessView
            setting={authSettings.unauthorizedUserAccess}
            setSetting={setSetting}
            text={authSettings.unauthorizedUserText}
            setText={setText}
        />
    );
};

export default UnauthorizedUserAccessSetting;
